
// TODO - generalize it to support more than just string arrays
export const getUniqueListItems = (list: string[]): string[] => {
  return Array.from(new Set(list));
};

type OptionType<T> = {
  label: string,
  value: string | T
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const transformDataIntoOptionType = <T extends Record<string, any>>(
  data: T[],
  getLabel: (item: T) => string,
  getValue: (item: T) => string | T,
  isDisabled: (item: T) => boolean,
): OptionType<T>[]=> {
  return data.map((d) => ({
    label: getLabel(d),
    value: getValue(d),
    isDisabled: isDisabled(d)
  }));
};
